import { AbstractControl } from '@angular/forms';

export interface AbstractControlWarn extends AbstractControl {
  warnings: unknown;
}

export function BudgetNoCostsReportedWarning(control: AbstractControlWarn) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const anyNonZero = parsedValue.some((pv) => pv.value && pv.value !== 0);
    const valObject = { [`BudgetNoCostsReportedWarning`]: true };

    control.warnings = anyNonZero ? undefined : valObject;
  } else {
    const valObject = { [`BudgetNoCostsReportedWarning`]: true };

    control.warnings = valObject;
  }
  // eslint-disable-next-line unicorn/no-useless-undefined
  return undefined;
}
